const PubNub = require('pubnub')

const self = {
  initializePubnub(game, env = process.env.NODE_ENV) {
    return new PubNub({
      subscribeKey: self.keyFor(game, env),
      logVerbosity: false
    })
  },

  keyFor(game, env = process.env.NODE_ENV) {
    game = require('@goodgamestudios/game-alias').name(game)
    /*
      **It’s ok to keep these keys here in plain text.**
      **These keys are public read-only keys.**

      Remember it’s perfectly fine to have those keys here as they will always
      become public once the web site includes this script and the whole world
      downloads it.

      The one thing I _could_ see instead is to move one set of keys (test/prod)
      to an environment variable, but keep in mind that parcel (or any bundler)
      will then again [just include them in the bundle][1]. So by putting them
      in the environment or an `.env` file you're effectively "just" introducing
      one more external dependency and redirection, without gaining any real
      effect on the result, which is that the keys will eventually be public.

      The whole idea of putting config vars in the environment still is valid
      for server-side things which usually have read/write permissions, and have
      access to private data.

      References:
      [1]: https://github.com/parcel-bundler/parcel/issues/255#issuecomment-351627247
      [2]: https://gitlab.goodgamestudios.com/cxf/cxf.js/issues/2
      [3]: https://parceljs.org/env.html
    */
    const subscribeKeys = {
      production: {
        bigfarm: '',
        empire: ''
      },
      //  Used  for pre-qa builds ( deployed builds from dev-branches)
      devtest: {
        bigfarm: 'sub-c-62182854-aba0-11e8-a6fb-8693ddbf4771',
        empire: 'sub-c-37a3fb44-b040-11e8-96e7-b288138ed50a'
      },
      //  Used by parcel for local builds
      development: {
        bigfarm: 'sub-c-62182854-aba0-11e8-a6fb-8693ddbf4771',
        empire: 'sub-c-37a3fb44-b040-11e8-96e7-b288138ed50a'
      },
      // Used by AVA for local tests and by QA for test-builds
      test: {
        bigfarm: 'sub-c-62182854-aba0-11e8-a6fb-8693ddbf4771',
        empire: 'sub-c-37a3fb44-b040-11e8-96e7-b288138ed50a'
      }
    }
    return subscribeKeys[env][game]
  }
}

module.exports = self
